import Accordion from './Accordion';
export { Accordion };
export { ACCORDION_REVEAL_EVENT, requestReveal } from './reveal';
export default Accordion;
